import React from 'react';
import Card, { CardBody } from './Card';
import Button from './Button';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  secondaryAction,
}) => {
  return (
    <Card variant="default" className="text-center py-16">
      <CardBody className="flex flex-col items-center">
        {icon && (
          <div className="w-16 h-16 bg-neutral-100 rounded-2xl flex items-center justify-center mb-6 text-neutral-400">
            {icon}
          </div>
        )}
        <h3 className="text-lg font-medium text-neutral-900 mb-2">{title}</h3>
        <p className="text-sm text-neutral-500 mb-6 max-w-sm">{description}</p>
        <div className="flex items-center gap-3">
          {action && (
            <Button
              variant="primary"
              size="sm"
              onClick={action.onClick}
              icon={action.icon}
            >
              {action.label}
            </Button>
          )}
          {secondaryAction && (
            <Button variant="secondary" size="sm" onClick={secondaryAction.onClick}>
              {secondaryAction.label}
            </Button>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default EmptyState;
